import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useBrandLogo from '../../hooks/useBrandLogo';
import { useT } from '../../i18n';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { Alert } from '../ui';
import './LegalPageLayout.css';

const messages = {
  back: { tr: '← Ana Sayfaya Dön', en: '← Back to Home' },
  updated: { tr: 'Son güncelleme: {date}', en: 'Last updated: {date} (Turkish original)' },
  turkishOnly: {
    tr: '',
    en: 'This document is currently available in Turkish only. The Turkish text is the binding version. For questions, write to destek@martinci.com.',
  },
};

// The legal texts themselves stay Turkish (a translated legal text needs
// legal review); in English the chrome is translated, `enTitle` is shown and
// a note says the Turkish text is the binding one.
export const LegalPageLayout = ({ title, enTitle, updatedAt, children }) => {
  const { t, lang } = useT(messages);
  const logo = useBrandLogo('blue');
  const shownTitle = lang === 'en' && enTitle ? enTitle : title;

  useEffect(() => {
    document.title = `${shownTitle} - Martinci`;
  }, [shownTitle]);

  return (
    <div className="legal-page">
      <header className="legal-topbar">
        <Link to="/" className="legal-brand-link">
          <img src={logo.src} alt={logo.alt} className="legal-logo" />
        </Link>
        <div className="legal-topbar-actions">
          <LanguageSwitcher tone="light" />
          <Link to="/" className="legal-back-link">{t('back')}</Link>
        </div>
      </header>

      <main className="legal-article">
        <h1>{shownTitle}</h1>
        {lang !== 'tr' && <Alert variant="info">{t('turkishOnly')}</Alert>}
        <div lang="tr">{children}</div>
        <p className="legal-updated-at">{t('updated', { date: updatedAt })}</p>
      </main>
    </div>
  );
};

export default LegalPageLayout;
